export const twitter = 'https://twitter.com/istat_it';
export const instagram = 'https://www.instagram.com/istat_it';
export const linkedin = 'https://it.linkedin.com/company/istat';
export const youtube = 'https://www.youtube.com/videoistat';
export const slideshare = 'https://www.slideshare.net/slideistat';
export const flickr = 'https://www.flickr.com/photos/galleria_istat/';
export const pinterest = 'https://www.pinterest.com/istat_infograf/';

export const sistan = 'https://www.sistan.it';
export const eurostat = 'https://ec.europa.eu/eurostat';
